import get from "lodash/get";
import * as Immutable from "immutable";
import SeriesConfig from "./SeriesConfig";
const parametersRegex = /\((.+)\)/;
const funcNameRegex = /(\w+)\(/;
const testSeriesRegex = /^(\w+)\((.*)(,(\w+))*\)$/;
const definitionFor = (type, parameters) => {
  const [field, parameter] = parameters;
  if (type === "percentile") {
    return { type, field, percentile: parameter };
  }
  if (type === "percentage") {
    return { type, field, strategy: parameter };
  }
  return { type, field };
};
export const isFunction = (s) => testSeriesRegex.test(s);
export const parseSeries = (s) => {
  const funcNameResult = funcNameRegex.exec(s);
  if (!funcNameResult) {
    return null;
  }
  const type = funcNameResult[1];
  const definition = {
    type
  };
  const parameterResult = parametersRegex.exec(s);
  if (!parameterResult) {
    return definition;
  }
  return definitionFor(type, parameterResult[1].split(","));
};
export default class Series {
  constructor(func, config = SeriesConfig.empty()) {
    this._value = { function: func, config };
  }
  get function() {
    return this._value.function;
  }
  get config() {
    return this._value.config;
  }
  get effectiveName() {
    const overridenName = get(this, "config.name");
    return overridenName || this.function;
  }
  toString() {
    return `Series: ${this.effectiveName}, config={${JSON.stringify(this.config)}}`;
  }
  toJSON() {
    return {
      config: this._value.config,
      function: this._value.function
    };
  }
  static fromJSON(value) {
    return new Series(value.function, SeriesConfig.fromJSON(value.config));
  }
  static forFunction(func) {
    return new Builder().function(func).config(SeriesConfig.empty()).build();
  }
  static create(func, field, parameter) {
    const optionalParameter = parameter ? `,${parameter}` : "";
    const functionWithField = `${func}(${field != null ? field : ""}${optionalParameter})`;
    return Series.forFunction(functionWithField);
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  function(newFunction) {
    return new Builder(this.value.set("function", newFunction));
  }
  config(newConfig) {
    return new Builder(this.value.set("config", newConfig));
  }
  parameter(newParameter) {
    return new Builder(this.value.set("parameter", newParameter));
  }
  build() {
    const { config } = this.value.toObject();
    const func = this.value.get("function");
    return new Series(func, config);
  }
}
